<div class="apg-panel">
  <div class="quick-quote-otp">
    <div class="quick-quote-otp__cube">

      <div [ngSwitch]="mode">
        <app-verify-otp *ngSwitchCase="'verify'" [quickQuote]="quickQuote" [otpContentKey]="otpContentKey"
                        [action]="action" (prev)="back.emit($event)" (next)="saveOtpId($event)">
        </app-verify-otp>

        <app-validate-otp *ngSwitchCase="'validate'" [preferredChannel]="preferredChannel" [otpId]="otpId"
                          [email]="email" [mobile]="mobile" (prev)="back.emit($event)" (next)="next.emit($event)">
        </app-validate-otp>
      </div>
    </div>
  </div>
</div>